import { useState } from "react";
import CartListItem from './cartListItem/cartListItem';
import { CheckoutButton } from "../buttons/checkoutButton/CheckoutButton";
import { getDatabase, ref, set, onValue } from "firebase/database";
import firebase from '../../utils/firebase';
import { CartImg } from './../../utils/svg';
import Select from './../buttons/select/Select';
import Input from './../buttons/input/Input';

import styles from './CartList.module.css';

export const CartList = ({
    cartList,
    addProductInCart,
    removeProductFromCart,
    deletePurchasedProduct
}) => {

    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');

    const totalPrices = [];


    //CALLBACK TAKE ADDRESS AND PHONE FROM SELECT
    let takeAddress = (value) => {
        setAddress(value)
    }

    let takePhone = (value) => {
        setPhone(value)
    }
    //TIME AND WHEN ORDER WAS CREATED
    const normalizeValue = (value) => {
        return value.toString().length > 1 ? value : `0${value}`;
    }
        let date = new Date();
        let orderCreated = Date.now()
    
        let hh = normalizeValue(date.getHours());
        let mm = normalizeValue(date.getMinutes());
    
        let time = `${hh}:${mm}`;

    const sendData = () => {
        const database = getDatabase(firebase);

        let sendSecond = () => {
            console.log(cartList)
            cartList.forEach(cart => {
            const { name, url, count, totalPrice } = cart;
            set(ref(database, `/checkout/${phone}/${name}`), {
                name,
                url,
                count,
                totalPrice,
            }
            )
        });
        }

        let send = () => {
                set(ref(database, `/checkout/${phone}/info`), {
                    time,
                    orderCreated,
                    address,
                    phone,
                    totalOrderSum,
                })
                
            sendSecond()
    
            // clearCartlist([])
            
            alert('Ваше замовлення прийнято, дякуємо що ви з нами!')
            //useHistory
        }

        if (phone.length === 0) {
            alert('Введіть номер мобільного телефону!')
        } else if (address.length === 0) {
            alert('Оберіть адресу!')
        } else {
            send()
        }
    }

    //TOTAL ORDER SUM
    for (let i = 0; i < cartList.length; i++) {
        totalPrices.push(Number(cartList[i].totalPrice))
    }

    const sumOrder = (arr) => {
        let sum = 0;
        for (let j = 0; j < arr.length; j++) {
            sum += arr[j]
        }
        return sum
    }

    const totalOrderSum = sumOrder(totalPrices)

    return (
        <div>
            { (cartList.length >= 1) ?
        <div className={styles.container}>
            {cartList.map((cartItem) => {

                return (
                    <div>
                        <CartListItem
                            cartItem={cartItem}
                            addProductInCart={addProductInCart}
                            removeProductFromCart={removeProductFromCart}
                            deletePurchasedProduct={deletePurchasedProduct}
                        />
                    </div>
                );
            })}
            <div className={styles.addressAndPhone}>
            <div className={styles.address}>
                <Select takeAddress={takeAddress}/>
            </div>
            <div className={styles.phone}>
                <Input takePhone={takePhone}/>
            </div>
            </div>


            <div className={styles.totalOrderSumContainer}>
                <p>Усього до сплати: <span className={styles.totalOrderSum}>{totalOrderSum}</span> грн</p>
            </div>
            
            <div className={styles.button}>
                {/* <input
                    type="text"
                    id="phone"
                    required={true}
                    value={phone}
                    placeholder="     мій номер телефону"
                    onChange={handlePhoneChange} /> */}
                <CheckoutButton sendData={sendData} />
            </div>
        </div>

:
        <div className={styles.cartImgContainer}>
                <CartImg />
                <div>
                    <span>У кошику немає товарів</span>
                </div>
            </div>
}

        </div>
    );
};
